'use client';

import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/buttons';
import { Modals } from '@/helpers/modals';
import { useNavigation } from '@/hooks/navigation';
import { useGetCommonStore, useModalsStore } from '@/store';
import {
  type EMissionBonusGroupKey,
  MISSION_LOTBOXES_GROUP_KEYS,
} from '../../helpers';
import { useMissionPrize } from '../../hooks/useMissionPrize';
import { useMissions } from '../../hooks/useMissions';

export const ButtonCTA = () => {
  const { t } = useTranslation();

  const useCommonStore = useGetCommonStore();
  const user = useCommonStore.use.user();

  const open = useModalsStore.use.open();

  const { navigate } = useNavigation();

  const { currentMission } = useMissions();

  const prize = useMissionPrize();

  const message = useMemo(() => {
    if (!user) return t('button.register');
    if (prize) return t('button.get-reward');
    if (currentMission.character === 0) return t('deposit');
    return t('button.go-lobby');
  }, [user, prize, currentMission, t]);

  const handle = useCallback(() => {
    if (!user) {
      open(Modals.Registration);
      return;
    }
    if (prize) {
      const groupKey = prize.groupKey as EMissionBonusGroupKey;
      if (MISSION_LOTBOXES_GROUP_KEYS.includes(groupKey)) {
        useCommonStore.setState({ activeLootboxId: prize.id });
      } else {
        navigate('/promotions?tab=active-bonuses');
      }
      return;
    }
    if (currentMission.character === 0) {
      open(Modals.Deposit);
      return;
    }
    navigate('/');
  }, [user, prize, currentMission, open, navigate]);

  return (
    <Button
      className="mission-button"
      onClick={handle}
      primary={!prize}
      secondary={!!prize}
    >
      {message}
    </Button>
  );
};
